var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-pagination',{staticClass:"mt-5",attrs:{"total-rows":_vm.items.total,"per-page":_vm.perPage,"align":"center"},on:{"change":_vm.pageChanged},model:{value:(_vm.items.current_page),callback:function ($$v) {_vm.$set(_vm.items, "current_page", $$v)},expression:"items.current_page"}})
}
var staticRenderFns = []

export { render, staticRenderFns }